import React, { useState } from 'react';
import emailjs from '@emailjs/browser';

const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [errorMessage, setErrorMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null); // 'success' or 'error'

  const handleChange = (event) => {
    const { name, value } = event.target;

    if (name === 'message') {
      const wordCount = value.trim().split(/\s+/).length;
      if (wordCount > 500) {
        setErrorMessage('Your message cannot exceed 500 words.');
        return;
      } else {
        setErrorMessage('');
      }
    }

    setFormData({ ...formData, [name]: value });
    setSubmitStatus(null); // Clear status when user types
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    
    if (errorMessage) {
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      // EmailJS configuration
      // IMPORTANT: Replace these with your EmailJS credentials
      // See EMAILJS_SETUP.md for detailed setup instructions
      // Get your credentials from: https://www.emailjs.com/
      const serviceId = 'YOUR_SERVICE_ID'; // Replace with your Service ID
      const templateId = 'YOUR_TEMPLATE_ID'; // Replace with your Template ID
      const publicKey = 'YOUR_PUBLIC_KEY'; // Replace with your Public Key
      
      // Check if credentials are configured
      if (serviceId === 'YOUR_SERVICE_ID' || templateId === 'YOUR_TEMPLATE_ID' || publicKey === 'YOUR_PUBLIC_KEY') {
        throw new Error('EmailJS credentials not configured. Please see EMAILJS_SETUP.md for setup instructions.');
      }

      // Send email using EmailJS
      await emailjs.send(
        serviceId,
        templateId,
        {
          from_name: formData.name,
          from_email: formData.email,
          message: formData.message,
          to_email: 'abatealemu52@gmail.com', // Your email address
        },
        publicKey
      );

      setSubmitStatus('success');
      setFormData({ name: '', email: '', message: '' });
      
      // Clear success message after 5 seconds
      setTimeout(() => {
        setSubmitStatus(null);
      }, 5000);
    } catch (error) {
      console.error('Email sending failed:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return React.createElement(
    'section',
    { className: 'contact container', style: styles.container },
    React.createElement(
      'div',
      { style: styles.headerSection },
    React.createElement(
      'h1',
        { style: styles.title },
        'Get In Touch'
      ),
      React.createElement(
        'p',
        { style: styles.subtitle },
        'Have a project in mind or want to collaborate? Feel free to reach out!'
      )
    ),
    React.createElement(
      'div',
      { style: styles.contentWrapper },
    React.createElement(
      'form',
        { onSubmit: handleSubmit, style: styles.form },
      React.createElement('input', {
        type: 'text',
        name: 'name',
        placeholder: 'Your Name',
        value: formData.name,
        onChange: handleChange,
          style: styles.input,
          required: true,
          disabled: isSubmitting,
      }),
      React.createElement('input', {
        type: 'email',
        name: 'email',
        placeholder: 'Your Email',
        value: formData.email,
        onChange: handleChange,
          required: true,
          style: styles.input,
          disabled: isSubmitting,
      }),
      React.createElement('textarea', {
        name: 'message',
          placeholder: 'Your Message (max 500 words)',
        value: formData.message,
        onChange: handleChange,
          required: true,
          style: styles.textarea,
          rows: 6,
          disabled: isSubmitting,
      }),
      errorMessage &&
          React.createElement('p', { style: styles.errorMessage }, errorMessage),
        submitStatus === 'success' &&
          React.createElement('p', { style: styles.successMessage }, 
            '✓ Message sent successfully! I will get back to you soon.'
          ),
        submitStatus === 'error' &&
          React.createElement('p', { style: styles.errorMessage }, 
            '✗ Failed to send message. Please try again or contact me directly at abatealemu52@gmail.com'
          ),
        React.createElement('button', { 
          type: 'submit', 
          disabled: !!errorMessage || isSubmitting,
          style: {
            ...styles.submitButton,
            ...(isSubmitting ? styles.submitButtonDisabled : {}),
          }
        }, isSubmitting ? 'Sending...' : 'Send Message') 
      ),
      React.createElement(
        'div',
        { style: styles.contactInfo },
        React.createElement(
          'h2',
          { style: styles.contactTitle },
          'Contact Information'
        ),
        React.createElement(
          'div',
          { style: styles.contactItem },
          React.createElement('strong', null, 'Email: '),
          React.createElement('a', { 
            href: 'mailto:abatealemu52@gmail.com',
            style: styles.link
          }, 'abatealemu52@gmail.com')
        ),
        React.createElement(
          'div',
          { style: styles.contactItem },
          React.createElement('strong', null, 'Phone: '),
          React.createElement('a', { 
            href: 'tel:+251901552962',
            style: styles.link
          }, '+251 901 55 2962')
    ),
    React.createElement(
      'div',
          { style: styles.contactItem },
          React.createElement('strong', null, 'Location: '),
          'Addis Ababa, Ethiopia'
        )
      )
    )
  );
};

const styles = {
  container: {
    padding: '40px 20px',
    maxWidth: '1000px',
    margin: '0 auto',
  },
  headerSection: {
    textAlign: 'center',
    marginBottom: '50px',
  },
  title: {
    fontSize: '3rem',
    color: 'white',
    marginBottom: '15px',
    fontWeight: '700',
    textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)',
  },
  subtitle: {
    fontSize: '1.2rem',
    color: 'rgba(255, 255, 255, 0.9)',
    lineHeight: '1.6',
  },
  contentWrapper: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '40px',
    alignItems: 'start',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    background: 'rgba(255, 255, 255, 0.95)',
    padding: '40px',
    borderRadius: '16px',
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
  },
  input: {
    padding: '15px',
    border: '2px solid #e0e0e0',
    borderRadius: '8px',
    fontSize: '1rem',
    transition: 'border-color 0.3s ease',
    fontFamily: 'inherit',
  },
  textarea: {
    padding: '15px',
    border: '2px solid #e0e0e0',
    borderRadius: '8px',
    fontSize: '1rem',
    transition: 'border-color 0.3s ease',
    fontFamily: 'inherit',
    resize: 'vertical',
  },
  errorMessage: {
    color: '#d32f2f',
    fontSize: '0.9rem',
    marginTop: '-10px',
  },
  successMessage: {
    color: '#2e7d32',
    fontSize: '0.9rem',
    marginTop: '-10px',
    fontWeight: '500',
  },
  submitButton: {
    backgroundColor: '#0077b6',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    padding: '15px 30px',
    fontSize: '1.1rem',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    marginTop: '10px',
  },
  submitButtonDisabled: {
    backgroundColor: '#90caf9',
    cursor: 'not-allowed',
    opacity: 0.7,
  },
  contactInfo: {
    background: 'rgba(255, 255, 255, 0.95)',
    padding: '40px',
    borderRadius: '16px',
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
  },
  contactTitle: {
    fontSize: '1.8rem',
    color: '#0077b6',
    marginBottom: '25px',
    fontWeight: '700',
  },
  contactItem: {
    fontSize: '1.1rem',
    color: '#555',
    marginBottom: '20px',
    lineHeight: '1.8',
  },
  link: {
    color: '#0077b6',
    textDecoration: 'none',
    transition: 'color 0.3s ease',
  },
};

export default Contact;
